import { FixedDecimal } from './FixedDecimal.js';
/**
 * Creates a {@link FixedDecimal} constructor for a currency.
 * @param decimalPlaces the number of decimal places for the currency
 */
const createTokenConstructor = (decimalPlaces, defaultFormatOptions) => (value) => new FixedDecimal(value, decimalPlaces, defaultFormatOptions);
/**
 * Constructs an amount of {@link AudioWei} from a fixed decimal string,
 * decimal number, or a bigint in the smallest denomination of AUDIO.
 *
 * AUDIO is used on the protocol dashboard and in the governance and staking
 * systems. Also used for calculating the balance totals of all connected
 * wallets and the Hedgehog wallet on the Rewards page.
 */
export const AUDIO = createTokenConstructor(18);
/**
 * Constructs an amount of {@link wAudioWei} from a fixed decimal string,
 * decimal number, or a bigint in the smallest denomination of wAUDIO.
 *
 * wAUDIO is used for in-app experiences, like tipping and rewards.
 */
export const wAUDIO = createTokenConstructor(8);
/**
 * Constructs an amount of {@link SolWei} from a fixed decimal string,
 * decimal number, or a bigint in the smallest denomination of SOL.
 *
 * SOL is used as an intermediary token for purchasing wAUDIO and for paying
 * for fees of Solana transactions on the platform.
 */
export const SOL = createTokenConstructor(9);
/**
 * Constructs an amount of {@link UsdcWei} from a fixed decimal string,
 * decimal number, or a bigint in the smallest denomination of USDC.
 *
 * USDC is used for purchasing content in-app, and getting "USD" prices via
 * Jupiter for the wAUDIO token and SOL.
 */
export const USDC = createTokenConstructor(6, {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
/**
 * Constructs an amount of {@link BonkWei} from a fixed decimal string,
 * decimal number, or a bigint in the smallest denomination of BONK.
 *
 * BONK is used for trading and swapping in the platform.
 */
export const BONK = createTokenConstructor(5);
//# sourceMappingURL=currencies.js.map